import { apiClientAuth } from "../http/httpClient";


export function OrderApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {

       /**
        * @route   POST /api/orders
        * @desc    Créer une nouvelle commande avec plusieurs produits
        * @access  Private (Authentifié)
        * @middleware validateCreateOrder - Valide les données de la commande
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        insert : (order) => https.post("/api/orders", order), 

       /**
        * @route   GET /api/orders/user/status/:status
        * @desc    Récupérer les commandes d'un utilisateur avec un statut spécifique
        * @access  Private (Authentifié)
        * @param   {integer} userId - Identifiant de l'utilisateur (a travers le token)
        * @param   {string} status - Statut de la commande (pending, delivered, canceled)
        * @middleware validateUserIdStatusParams - Valide les paramètres userId et status
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        findAll : (orderStatus) => https.get(`/api/orders/user/status/${orderStatus}`),

       /**
        * @route   PUT /api/orders/:id/status
        * @desc    Mettre à jour le statut d'une commande
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant de la commande
        * @body    {string} status - Nouveau statut (pending, delivered, canceled)
        * @body    {string} [adminEmail] - Email du modérateur (requis si status = delivered)
        * @middleware validateOrderId - Valide le paramètre ID
        * @middleware validateUpdateStatus - Valide les données de la mise à jour
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        update: (id, orderStatus) => https.put(`/api/orders/${id}/status`, orderStatus),

       /**
        * @route   GET /api/orders/:id
        * @desc    Récupérer une commande spécifique avec tous les produits et leurs images
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant de la commande
        * @middleware validateOrderId - Valide le paramètre ID
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        findOne: (id) => https.get(`/api/orders/${id}`),


    };
}

